import React, { useEffect, useState } from "react";
import { AlertItem } from "../../models/Dashboard";
import "./DashboardStyleSheet.css";

const SEVERITY_STYLES = {
    info: { bg: "#eff6ff", border: "#bfdbfe", icon: "ℹ️" },
    warning: { bg: "#fffbeb", border: "#fcd34d", icon: "⚠️" },
    critical: { bg: "#fef2f2", border: "#fca5a5", icon: "🔴" },
};

const AlertsBanner: React.FC<{ alerts: AlertItem[] }> = ({ alerts }) => {
    const [dismissed, setDismissed] = useState<Set<string>>(new Set());
    const visible = alerts.filter(a => !dismissed.has(a.id));
    if (!visible.length) return null;

    return (
        <div className="alerts-banner">
            {visible.map(alert => {
                const style = SEVERITY_STYLES[alert.severity as keyof typeof SEVERITY_STYLES];
                return (
                    <div
                        key={alert.id}
                        className="alert-item"
                        style={{ background: style.bg, borderColor: style.border }}
                    >
                        <span className="alert-icon">{style.icon}</span>
                        <div className="alert-content">
                            <strong>{alert.title}</strong>
                            {alert.description && <span> — {alert.description}</span>}
                        </div>
                        <button
                            className="alert-dismiss"
                            onClick={() => setDismissed(prev => new Set([...prev, alert.id]))}
                        >×</button>
                    </div>
                );
            })}
        </div>
    );
};

export default AlertsBanner;